import React, { Component } from 'react';
import _ from 'lodash';
import { Column, Table } from 'react-virtualized';
import InfiniteList from './InfiniteList';
import DoctorAlertCSV from './DoctorAlertCSV';
import Alert from './Alert';
import MessageSendDialog from './MessageSendDialog';
import ConfirmationModal from './ConfirmationModal';

const Api = require('./Config');

export default class DoctorAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alerts: [],
      showMessageModal: false,
      isMessageModalLoading: false,
      showConfirmationModal: false,
      isConfirmationModalLoading: false,
      selectedTcodes: [],
      staticTemplate: null,
      appId: null,
    };

    this.loadRows = this.loadRows.bind(this);
    this.clearAlert = this.clearAlert.bind(this);
    this.clearAllAlerts = this.clearAllAlerts.bind(this);
    this.getTableCell = this.getTableCell.bind(this);
    this.sendAlerts = this.sendAlerts.bind(this);
    this.getAllAlertTcodes = this.getAllAlertTcodes.bind(this);
  }

  async loadRows(startIdx, queryAmount) {
    const results = await Api.getAlertForDoctor(startIdx, queryAmount);
    let alertItems = results.DATA;
    if (startIdx > 0) {
      alertItems = this.state.alerts.concat(alertItems);
    }
    this.setState({ alerts: alertItems });

    return {
      data: results.DATA,
      maxRows: results.maxRows,
    };
  }

  async getAllAlertTcodes() {
    const results = await Api.getAlertForDoctor(0, 50, 'Y');
    return results.DATA;
  }

  clearAlert(tcode) {
    Api.clearAlert(tcode).then(() => {
      const newAlerts = this.state.alerts.filter((item) => item.t_code != tcode);
      this.setState({ alerts: newAlerts });
    });
  }

  clearAllAlerts(t_codes, showNotification = false) {
    Api.clearAlert(t_codes.join(',')).then(() => {
      this.loadRows(0);
      if (showNotification) {
        this.setState({ showConfirmationModal: false, isConfirmationModalLoading: false });
        this.alert.open('Alerts', 'Successfully cleared all alerts');
      }
    });
  }

  async sendAlerts(title, message, link, category_id) {
    const { selectedTcodes } = this.state;

    if (selectedTcodes.length <= 0) {
      this.setState({ showMessageModal: false });
      this.alert.open('Alerts', 'No alerts found');
      return true;
    }

    this.setState({ isMessageModalLoading: true });

    let successMessageTcodes = [];
    let failedMessageTcodes = [];
    let failedMessageErrors = [];

    for (let i = 0; i < selectedTcodes.length; i++) {
      const tcodeItem = selectedTcodes[i];

      try {
        const response = await Api.sendMessageToTCode(tcodeItem, title, message, link, category_id);
        if (response.SUCCESS === false) {
          failedMessageTcodes.push(tcodeItem);
          if (response.ERROR && response.ERROR.includes('No devices found')) {
            failedMessageErrors.push(`Error ${tcodeItem}: No devices found`);
          } else {
            failedMessageErrors.push(`Error ${tcodeItem}: ${response.ERROR}`);
          }
        } else {
          successMessageTcodes.push(tcodeItem);
        }
      } catch (err) {
        failedMessageTcodes.push(tcodeItem);
        if (response.ERROR && response.ERROR.includes('No devices found')) {
          failedMessageErrors.push(`Error ${tcodeItem}: No devices found`);
        } else {
          failedMessageErrors.push(`Error ${tcodeItem}: ${response.ERROR}`);
        }
      }
    }

    let notificationMessage = '';
    if (successMessageTcodes.length > 0) {
      if (selectedTcodes.length > 1) {
        this.clearAllAlerts(successMessageTcodes);
        notificationMessage += `${successMessageTcodes.length} Tcodes successfully sent and cleared. \n`;
      } else {
        this.clearAlert(successMessageTcodes[0]);
        notificationMessage += `${successMessageTcodes[0]} Tcode successfully sent and cleared. \n`;
      }
    }

    if (failedMessageTcodes.length > 0) {
      if (selectedTcodes.length > 1) {
        notificationMessage += ` ${failedMessageTcodes.length} Tcodes failed. \n`;
      } else {
        notificationMessage += ` ${failedMessageTcodes.length} Tcode failed. \n`;
      }

      notificationMessage += failedMessageErrors.join('\n');
    }

    this.setState({ isMessageModalLoading: false, showMessageModal: false });
    this.alert.open('Alerts', notificationMessage);
    return true;
  }

  openSingleMessageModal(single) {
    this.setState({
      selectedTcodes: [single.t_code],
      showMessageModal: true,
      staticTemplate: null,
      appId: single.app_id,
    });
  }

  getTableCell({ cellData, dataKey, rowData, rowIndex }) {
    let cellItem;

    switch (dataKey) {
      case 'row_idx':
        cellItem = rowIndex + 1;
        break;
      case 't_code':
        cellItem = (
          <span
            onClick={() => {
              this.props.history.push(`/JourneyDetail/${cellData}`);
            }}
            style={{ color: 'blue', cursor: 'pointer' }}
          >
            {Api.formatTCode(cellData)}
          </span>
        );
        break;
      case 'last_alert_cleared_date':
        cellItem = Api.getDateFormat(cellData);
        break;
      case 'clear':
        cellItem = (
          <>
            <div onClick={() => this.openSingleMessageModal(rowData)} className="btn">
              <i style={{ fontSize: 30, color: '#5cb85c' }} className="fa fa-envelope" aria-hidden="true"></i>{' '}
            </div>
            <div onClick={() => this.clearAlert(rowData.t_code)} className="btn">
              <i style={{ fontSize: 30, color: '#ff0000' }} className="fa fa-trash" aria-hidden="true"></i>{' '}
            </div>
          </>
        );
        break;
    }

    return cellItem;
  }

  render() {
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h3>Alerts</h3>
          <div>
            <button
              style={{ marginRight: 20 }}
              onClick={async () => {
                const tcodes = await this.getAllAlertTcodes();
                this.setState({
                  selectedTcodes: tcodes,
                  showMessageModal: true,
                  appId: null,
                  staticTemplate: {
                    title: `IMPORTANT MESSAGE from your health care provider's office`,
                    body: 'Reminder to reply to the check-ins we send you. This is an important part of your Care Plan.',
                    link: '',
                    view_title: 'NO REPLIES - ENGAGEMENT',
                    category_id: '8',
                    category_name: 'No Replies - Engagement',
                  },
                });
              }}
              className="btn btn-success"
            >
              Send Message To All
            </button>
            <button
              style={{ marginRight: 20 }}
              onClick={async () => {
                const tcodes = await this.getAllAlertTcodes();
                this.setState({ selectedTcodes: tcodes, showConfirmationModal: true });
              }}
              className="btn btn-danger"
            >
              Clear All
            </button>
            <DoctorAlertCSV />
          </div>
        </div>
        <InfiniteList lists={this.state.alerts} loadRows={this.loadRows}>
          {({ onRowsRendered, registerChild, width }) => (
            <Table
              ref={registerChild}
              onRowsRendered={onRowsRendered}
              width={width}
              height={800}
              headerHeight={60}
              rowStyle={{
                borderBottom: '1px solid #ddd',
                paddingTop: 10,
                paddingBottom: 10,
              }}
              rowHeight={60}
              rowCount={this.state.alerts.length}
              rowGetter={({ index }) => this.state.alerts[index]}
            >
              <Column label="#" dataKey="row_idx" cellRenderer={this.getTableCell} width={width / 10} />
              <Column label="Patient" dataKey="patient_ref" width={width / 5} />
              <Column label="T-Code" dataKey="t_code" cellRenderer={this.getTableCell} width={width / 7} />
              <Column label="Journey" dataKey="journey_name" width={width / 3} />
              <Column label="Missed since" dataKey="diff" width={width / 7} />
              <Column
                label="Last Alert Cleared Date"
                dataKey="last_alert_cleared_date"
                cellRenderer={this.getTableCell}
                width={width / 6}
              />
              <Column label="" dataKey="clear" cellRenderer={this.getTableCell} width={width / 8} />
            </Table>
          )}
        </InfiniteList>
        <Alert ref={(ref) => (this.alert = ref)} />
        <MessageSendDialog
          sendAction={this.sendAlerts}
          onClose={() => {
            this.setState({ showMessageModal: false });
          }}
          show={this.state.showMessageModal}
          t_code={this.state.selectedTcodes}
          isLoading={this.state.isMessageModalLoading}
          staticTemplate={this.state.staticTemplate}
          app_id={this.state.appId}
        />
        <ConfirmationModal
          show={this.state.showConfirmationModal}
          title="Confirm Clear All Alerts"
          confirmationText={`Are you sure you want to clear all ${this.state.selectedTcodes.length} Tcodes?`}
          isLoading={this.state.isConfirmationModalLoading}
          handleConfirm={() => {
            if (this.state.selectedTcodes.length <= 0) {
              this.setState({ showConfirmationModal: false });
              this.alert.open('Alerts', 'No alerts found');
            } else {
              this.setState({ isConfirmationModalLoading: true });
              this.clearAllAlerts(this.state.selectedTcodes, true);
            }
          }}
          handleClose={() => {
            this.setState({ showConfirmationModal: false });
          }}
        />
      </div>
    );
  }
}
